var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 3.50012H5.83333C4.54417 3.50012 3.5 4.54429 3.5 5.83346V22.1668C3.5 23.456 4.54417 24.5001 5.83333 24.5001H14.7245V16.379H11.991V13.1998H14.7245V10.8606C14.7245 8.14929 16.3823 6.67112 18.802 6.67112C19.6175 6.66879 20.4318 6.71079 21.2427 6.79362V9.62862H19.5767C18.2583 9.62862 18.0017 10.2516 18.0017 11.171V13.1951H21.1517L20.7422 16.3743H17.983V24.5001H22.1667C23.4558 24.5001 24.5 23.456 24.5 22.1668V5.83346C24.5 4.54429 23.4558 3.50012 22.1667 3.50012Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlackIcon);
export default __webpack_public_path__ + "static/media/Facebook_black_icon.8764d99ab8c0b89c03e2171cb6222398.svg";
export { ForwardRef as ReactComponent };